import React, { useState, useEffect,useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import centerImage from '../../assets/secorex.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import UsernameContext from './UsernameContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
  margin-top: 39px;
`;

const Image = styled.img`
  width: 270px;
  height: 66px;
  margin-bottom: 30px;
`;

const SubHeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  font: normal normal bold 28px/42px 'Segoe UI', sans-serif;
  letter-spacing: 0.5px;
  color: #2B3497;
  min-height: 50px;
`;

const FailedMessage = styled.div`
  color: red;
  font: normal normal bold 20px/28px 'Segoe UI', sans-serif;
  max-width: 600px;
  text-align: center;
  margin: 20px auto;
  padding: 0 20px;
  word-wrap: break-word;
  animation: fadeIn 0.5s ease forwards;
  min-height: 50px;

`;

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  40% {
    transform: scale(1.4);
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Dot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: #2B3497;
  animation: ${bounce} 1.4s infinite;
  animation-delay: ${(props) => props.delay};
`;

const VerifyButton = styled.button`
  background: linear-gradient(#2B3497, #7177B7, #2B3497);
  box-shadow: 0px 10px 20px #2B34976E;
  border-radius: 6px;
  width: 163px;
  height: 37px;
  font: normal normal 600 21px/26px Segoe UI;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: capitalize;
  opacity: 1;
  border: none;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    opacity: 0.9;
  }
`;

const SSOLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showFailure, setShowFailure] = useState(false);
  const { setUsername } = useContext(UsernameContext); // Access setUsername function from context

  useEffect(() => {
    handleSSOLogin();
  }, []);

  const handleSSOLogin = () => {
    setLoading(true);
    setShowFailure(false);
  
    const SSO_API_URL = `${window.APP_CONFIG.SECONDARY_API_URL}/User/SSOLogin`;
  
    axios
      .get(SSO_API_URL, { withCredentials: true })
      .then((response) => {
        // Check for 204 No Content
        if (response.status === 204) {
          setShowFailure(true);
          setTimeout(() => {
            navigate('/login');
          }, 2000);
          return;
        }
  
        const data = response.data;
        if (data?.username) {
          console.log("Logged in as:", data.username);
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('loginUsername', data.username);
          localStorage.setItem('token',data.token);
          setUsername(data.username); // Set username to context
          navigate('/layout/Dashboard/Dashboard');
        } else {
          setShowFailure(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setShowFailure(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  return (
    <Container>
      <Image src={centerImage} alt="OTP Image" />
      {loading ? (
        <SubHeadingWrapper>
          Authenticating
          <div style={{ display: 'flex', marginLeft: 10 }}>
            <Dot delay="0s" />
            <Dot delay="0.2s" />
            <Dot delay="0.4s" />
          </div>
        </SubHeadingWrapper>
      ) : showFailure ? (
        <>
          <FailedMessage>Unable to complete authentication. You may not have access, or the authentication service may be temporarily unavailable. Please try again later or contact support!</FailedMessage>
          {/* <VerifyButton onClick={handleSSOLogin}>Retry</VerifyButton> */}
        </>
      ) : null}
    </Container>
  );
};

export default SSOLoginPage;
